var map = {
	"./blogs/blogs.module": [
		"./src/app/blogs/blogs.module.ts",
		"common",
		"blogs-blogs-module"
	],
	"./cart/cart.module": [
		"./src/app/cart/cart.module.ts",
		"default~cart-cart-module~my-account-my-account-module",
		"cart-cart-module"
	],
	"./my-account/my-account.module": [
		"./src/app/my-account/my-account.module.ts",
		"default~cart-cart-module~my-account-my-account-module",
		"my-account-my-account-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	],
	"./posts/posts.module": [
		"./src/app/posts/posts.module.ts",
		"posts-posts-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"common",
		"products-products-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;